import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import {
  Box, Container, makeStyles, Divider,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    paddingTop: theme.spacing(3),
  },

}));

const InformationPagesViewSkeleton = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Container>
        <Box display="flex">
          {[...Array(3)].map((index) => (
            <Box pr={2} key={index}>
              <Skeleton variant="rect" width={70} height={16} />

            </Box>
          ))}
        </Box>
        <Box my={3}>
          <Skeleton variant="rect" width="50%" height={50} />
        </Box>
      </Container>
      <Divider light />

      <Container>
        <Box py={3}>
          <Box mb={3}>
            <Skeleton variant="rect" width="50%" height={48} />
          </Box>
          {[...Array(5)].map((index) => (
            <Box my={2} key={index}>
              <Box mb={1}>
                <Skeleton variant="rect" width="40%" height={26} />
              </Box>
              <Box mb={0.5}>
                <Skeleton variant="rect" width="100%" height={16} />
              </Box>
              <Skeleton variant="rect" width="25%" height={16} />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};
export default InformationPagesViewSkeleton;
